import { render, staticRenderFns } from "./LayoutTwo.vue?vue&type=template&id=70883348&"
import script from "./LayoutTwo.vue?vue&type=script&lang=js&"
export * from "./LayoutTwo.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTwo.vue?vue&type=style&index=0&id=70883348&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports